import ChevronToggle from "../components/ChevronToggle";
import SelectizeWithCreate from "../components/SelectizeWithCreate";

export default class ArticleJobsSettings {
  constructor(params) {
    this.params = params;
  }

  show() {
    new ChevronToggle();
    new SelectizeWithCreate();
  }
}
